import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Button, InputNumber } from "antd";
import { putOrderDetailCreate } from "../../../../../../services/orderManagement.service";
import { swalNotification } from "../../../../../../components/alret/notificztion";
import { validationErrors } from "../../../../../../utils/Helpers";
const { Option } = Select;
const dataType = [
  {
    label: "Cash Out",
    value: "cash_out",
  },
  {
    label: "Less Product",
    value: "less_product",
  },
];
const ModalTaskIssueCreate = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [orderID, setorderID] = useState(null);
  useEffect(() => {
    if (props.visible) {
      const orderdate = {
        orderId: props.taskid,
      };
      setorderID(orderdate);
      // console.log("ID NEW", orderID);
    }
  }, [props.visible]);
  const postLists = async () => {
    const orderdate = {
      orderId: props.taskid,
    };
    setorderID(orderdate);
    // console.log("ID NEW", orderID);
  };
  // const dataConvert = (values) => {
  //   values.map((item, idx) => {
  //     const editOrderData = {
  //       pickup: item.pickup,
  //       delivery: item.delivery,
  //     };
  //     setPostDataOrderView(editOrderData);
  //   });
  // };

  const handleCancel = () => {
    props.setvisible(false);
  };
  // // Modal Form

  // const okhandlePickup = async (values) => {
  //   try {
  //     await putOrderDetailEdit(postDataOrderIDF, values);
  //   } catch (e) {
  //     // console.log("resp at handleCancelPickup =>> ", e);
  //     throw e;
  //   }
  // };
  // const okhandleDeliver = async (values) => {
  //   try {
  //     await putOrderDetailEdit(postDataOrderIDS, values);
  //   } catch (e) {
  //     throw e;
  //   }
  // };

  const onFinish = async (values) => {
    // console.log("Submit", values);
    // return null;
    try {
      setMBtnLoading(true);
      const resp = await putOrderDetailCreate(values);
      // console.log("create issue resp ", resp);
      swalNotification(
        "Order Issue Create",
        "Issue Create has been Change successfully",
        "success"
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };

  useEffect(() => {
    form.setFieldsValue(orderID);
  }, [orderID]);
  const [form] = Form.useForm();

  return (
    <Modal
      title={`Create Issue #${props.taskid}`}
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button
          form="modalFormCreateIssue"
          loading={MBtnLoading}
          htmlType="submit"
          //  disabled={postDataReason == null}
        >
          Save
        </Button>,
      ]}
    >
      <Form
        form={form}
        id="modalFormCreateIssue"
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item hidden name={"orderId"}>
          <Input />
        </Form.Item>
        <Form.Item
          name={"reason"}
          label={"Reason"}
          rules={[{ required: true, message: "Reason is Required" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={"type"}
          label={"Type"}
          rules={[{ required: true, message: "Type is Required" }]}
        >
          <Select style={{ width: "100%" }}>
            {dataType &&
              dataType.map((item) => (
                <Option value={item.value}>{item.label}</Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={"amount"}
          label={"Amount"}
          rules={[{ required: true, message: "Amount is Required" }]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default ModalTaskIssueCreate;
